var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgForward = function SvgForward(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 12,
    "data-width-24": 18,
    viewBox: "0 0 18 16.1",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.552 13.543a.6.6 0 0 1-.245.05.61.61 0 0 1-.452-.193.67.67 0 0 1 0-.931l4.83-4.973H7.044c-.968 0-2.37.386-3.527 1.54-1.144 1.14-2.116 3.1-2.116 6.37a.7.7 0 1 1-1.4 0c0-3.56 1.067-5.906 2.528-7.362 1.447-1.443 3.218-1.948 4.515-1.948h8.659l-4.847-4.989a.67.67 0 0 1 .016-.914.63.63 0 0 1 .889-.016l5.97 6.146a.67.67 0 0 1 0 .93L11.76 13.4a.6.6 0 0 1-.208.143",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgForward);
export default ForwardRef;